import NavBar from '@/components/NavBar/NavBar.vue';
import Sidebar from '@/components/sidebar/SidebarComponent.vue';
import AppFooter from '@/components/Footer/AppFooter.vue';

export default {
    name: 'ComponentDashboard',
    components: {
      NavBar,
      Sidebar,
      AppFooter
  },
};